// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as SupItems from "./SupItems.bs.js";
import * as SupUnits from "./SupUnits.bs.js";
import * as SupTraits from "./SupTraits.bs.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as SupAugments from "./SupAugments.bs.js";
import * as SupPowerups from "./SupPowerups.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as SupTacticians from "./SupTacticians.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as SupStarterPack from "./SupStarterPack.bs.js";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

function navTabLabel(v) {
  switch (v) {
    case /* General */0 :
        return "gameplay";
    case /* Units */1 :
        return "units";
    case /* Traits */2 :
        return "traits";
    case /* Items */3 :
        return "items";
    case /* Augments */4 :
        return "augments";
    case /* Tacticians */5 :
        return "tacticians";
    case /* Charms */6 :
        return "charms";
    
  }
}

var topStates = {
  contents: {
    units: 9999,
    traits: 9999,
    items: 9999,
    augments: 9999,
    tacticians: 9999,
    charms: 9999
  }
};

function getTop(id) {
  return Belt_Option.getExn(Caml_option.nullable_to_opt(document.getElementById(id))).getBoundingClientRect().top;
}

function recalcTopStates(param) {
  var pageY = window.pageYOffset;
  var unitsTop = getTop("set-update-units");
  var traitsTop = getTop("set-update-traits");
  var itemsTop = getTop("set-update-items");
  var augmentsTop = getTop("set-update-augments");
  var tacticiansTop = getTop("set-update-tacticians");
  var charmsTop = getTop("set-update-charms");
  topStates.contents = {
    units: pageY + unitsTop,
    traits: pageY + traitsTop,
    items: pageY + itemsTop,
    augments: pageY + augmentsTop,
    tacticians: pageY + tacticiansTop,
    charms: pageY + charmsTop
  };
  
}

function Set9UpdatePage$Inner(Props) {
  var anomalies = Props.anomalies;
  var t = Translation.useT(/* Common */0);
  var match = React.useState(function () {
        return /* General */0;
      });
  var setTab = match[1];
  var screenSize = ScreenAtom.use(undefined);
  React.useEffect((function () {
          recalcTopStates(undefined);
          document.addEventListener("scroll", (function (e) {
                  var y = window.scrollY;
                  var topStates$1 = topStates.contents;
                  if (y > topStates$1.tacticians - 150) {
                    return Curry._1(setTab, (function (param) {
                                  return /* Tacticians */5;
                                }));
                  } else if (y > topStates$1.augments - 150) {
                    return Curry._1(setTab, (function (param) {
                                  return /* Augments */4;
                                }));
                  } else if (y > topStates$1.items - 150) {
                    return Curry._1(setTab, (function (param) {
                                  return /* Items */3;
                                }));
                  } else if (y > topStates$1.charms - 150) {
                    return Curry._1(setTab, (function (param) {
                                  return /* Charms */6;
                                }));
                  } else if (y > topStates$1.traits - 150) {
                    return Curry._1(setTab, (function (param) {
                                  return /* Traits */2;
                                }));
                  } else if (y > topStates$1.units - 150) {
                    return Curry._1(setTab, (function (param) {
                                  return /* Units */1;
                                }));
                  } else {
                    return Curry._1(setTab, (function (param) {
                                  return /* General */0;
                                }));
                  }
                }), {
                capture: false,
                once: false,
                passive: true
              });
          
        }), []);
  return React.createElement("div", {
              className: "flex flex-col items-center"
            }, React.createElement("div", {
                  className: "flex flex-col items-center w-[375px] sm:w-[650px] md:w-[970px]"
                }, React.createElement("div", {
                      className: "relative mt-8 w-[320px] sm:w-[640px] md:w-[960px] h-[320px] sm:h-[640px] md:h-[960px]"
                    }, React.createElement("img", {
                          className: "rounded",
                          height: "960",
                          src: "https://ap.tft.tools/img/gg17/keyart.jpg?w=960",
                          width: "960"
                        })), React.createElement(ContentSection.make, {
                      id: "set-update-gameplay",
                      className: "mt-12 leading-tight",
                      children: null
                    }, React.createElement("div", {
                          className: "grid grid-cols-1 md:grid-cols-2 gap-8 md:w-[960px]"
                        }, React.createElement("div", undefined, React.createElement("h2", {
                                  className: "h2 pb-2"
                                }, "Teamfight Tactics: Enchanted Wilds"), React.createElement("div", {
                                  className: "leading-snug"
                                }, React.createElement("div", undefined, "Set in a mystical forest teeming with ancient magic, colossal creatures, and whimsical spirits, Set 18 invites players to carve their own path through a vibrant ecosystem of new traits, champions, mechanics, and strategies."), React.createElement("div", {
                                      className: "mt-2"
                                    }, "At the heart of Enchanted Wilds are Wisps, magical denizens that appear in players' shops as temporary, single-use sources of power. Inspired by the beloved Charms mechanic from Magic N' Mayhem, Wisps offer strategic choices through combat boosts, economic rewards, experience gains, and high-risk, high-reward deals."))), React.createElement("iframe", {
                              className: "hidden md:block",
                              width: screenSize === /* Xs */5 ? "320" : "448",
                              height: screenSize === /* Xs */5 ? "180" : "252",
                              src: "https://www.youtube.com/embed/HNeO1nRMK1E?si=aOO8l0ERU-V3yXI7",
                              title: "Enchanted Wilds",
                              frameborder: "0",
                              allow: "fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                              allowfullscreen: true
                            })), React.createElement("div", undefined, React.createElement("h3", {
                              className: "h3 mt-6"
                            }, "Set Mechanic: Wisps"), React.createElement("div", {
                              className: "mt-2"
                            }, "The evolution from Charms to Wisps brings notable tweaks to the mechanic, such as improved clarity, expanded variety, upgraded visuals, and new progression systems that deepen the mechanic throughout a match."), React.createElement("div", {
                              className: "mt-2"
                            }, "Core rules from the past: Wisps appear in the rightmost shop slot, players can purchase one Wisp per round, and after purchasing one you won’t see more for the rest of the round. These rules can be broken by the Blossom trait and certain Wisps."), React.createElement("div", {
                              className: "mt-2"
                            }, "Wisps have 7 color-coded categories: Champion, Combat, Gold/XP, Item, Misc, Risky, Shop"), React.createElement("div", {
                              className: "mt-2"
                            }, "Wisps appear in every other shop. After stage 5, every other Wisp will be from the Combat category."), React.createElement("div", {
                              className: "mt-2"
                            }, "Wisps disappear from the shop slot after planning phase or purchase, revealing the shop unit behind it."), React.createElement("div", {
                              className: "mt-2"
                            }, "Stronger Wisps appear as the game progresses, and many Wisps have special conditions in order to be offered. For example, Hand of Baron requires the Riftbeast trait to be active.")), React.createElement("iframe", {
                          className: "block mt-4 md:hidden",
                          width: screenSize === /* Xs */5 ? "320" : "448",
                          height: screenSize === /* Xs */5 ? "180" : "252",
                          src: "https://www.youtube.com/embed/IOnfAHUDM10?si=2U2ULu-PAGx3SvJI",
                          title: "Enchanted Wilds",
                          frameborder: "0",
                          allow: "fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                          allowfullscreen: true
                        })), React.createElement("div", {
                      className: "p-6 py-5 bg-secondary-4 border border-secondary-11 mt-8 leading-tight rounded"
                    }, React.createElement("div", undefined, "Enchanted Wilds will be available on PBE Tuesday, July 28th afternoon PT."), React.createElement("div", {
                          className: "mt-1"
                        }, "It will launch on live servers Wednesday, August 26th with patch 18.1.")), React.createElement(SupStarterPack.make, {}), React.createElement("div", {
                      className: "sticky mt-8 z-10 top-[47px] w-full sm:w-[650px] md:w-[970px]"
                    }, React.createElement("div", {
                          className: "bg-bg0"
                        }, React.createElement(Tabs, {
                              variant: "scrollable",
                              children: null,
                              value: match[0],
                              onChange: (function (param, t) {
                                  Curry._1(setTab, (function (param) {
                                          return t;
                                        }));
                                  recalcTopStates(undefined);
                                  var top = Belt_Option.getExn(Caml_option.nullable_to_opt(document.getElementById("set-update-" + navTabLabel(t)))).getBoundingClientRect().top + window.pageYOffset - 140;
                                  window.scrollTo({
                                        behavior: "smooth",
                                        left: 0,
                                        top: top
                                      });
                                  
                                })
                            }, React.createElement(Tab, {
                                  label: t("Gameplay"),
                                  value: /* General */0
                                }), React.createElement(Tab, {
                                  label: t("Units"),
                                  value: /* Units */1
                                }), React.createElement(Tab, {
                                  label: t("Traits"),
                                  value: /* Traits */2
                                }), React.createElement(Tab, {
                                  label: t("Wisps"),
                                  value: /* Charms */6
                                }), React.createElement(Tab, {
                                  label: t("Augments"),
                                  value: /* Augments */4
                                }), React.createElement(Tab, {
                                  label: t("Cosmetics"),
                                  value: /* Tacticians */5
                                })))), React.createElement(SupUnits.make, {}), React.createElement(SupTraits.make, {}), React.createElement(SupPowerups.make, {
                      anomalies: anomalies
                    }), React.createElement(SupItems.make, {}), React.createElement(SupAugments.make, {}), React.createElement(SupTacticians.make, {})));
}

var Inner = {
  make: Set9UpdatePage$Inner
};

function Set9UpdatePage(Props) {
  var anomalies = Props.anomalies;
  return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set18 */10, React.createElement(Set9UpdatePage$Inner, {
                      anomalies: anomalies
                    }), undefined));
}

var make = Set9UpdatePage;

export {
  navTabLabel ,
  topStates ,
  getTop ,
  recalcTopStates ,
  Inner ,
  make ,
  
}
/* react Not a pure module */
